export type TrumpAccountCheckSelectionState = {
  yes: boolean;
  no: boolean;
};

export type TrumpAccountCheckSelectionAction = {
  type: TrumpAccountCheckSelectionType;
};

export enum TrumpAccountCheckSelectionType {
  Yes = "yes",
  No = "no",
}
